import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element } from 'common/types/tracking';

export enum TrackingEvent {
  Click = 'refer-a-friend-section_click',
}

export enum TrackingInteraction {
  CopyReferralLink = 'copy_referral_link',
  ShareReferralLink = 'share_referral_link',
  Login = 'login',
}

export const trackReferAFriendClick = (button_text: string, interaction: TrackingInteraction) =>
  dispatchTrackingEventGA4({
    event: TrackingEvent.Click,
    element: Element.Button,
    button_text,
    interaction,
  });
